import { render, staticRenderFns } from "./DistortionReportDetail.vue?vue&type=template&id=462b6143&scoped=true"
import script from "./DistortionReportDetail.vue?vue&type=script&lang=js"
export * from "./DistortionReportDetail.vue?vue&type=script&lang=js"
import style0 from "./DistortionReportDetail.vue?vue&type=style&index=0&id=462b6143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b6143",
  null
  
)

export default component.exports